/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PublicPlatformDTO
 */
export interface PublicPlatformDTO {
  /**
   *
   * @type {number}
   * @memberof PublicPlatformDTO
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof PublicPlatformDTO
   */
  name: string;
}

/**
 * Check if a given object implements the PublicPlatformDTO interface.
 */
export function instanceOfPublicPlatformDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;

  return isInstance;
}

export function PublicPlatformDTOFromJSON(json: any): PublicPlatformDTO {
  return PublicPlatformDTOFromJSONTyped(json, false);
}

export function PublicPlatformDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicPlatformDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"]
  };
}

export function PublicPlatformDTOToJSON(value?: PublicPlatformDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name
  };
}
